import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Panel, LiveTag } from "../components/common/Panel";
import { getBlocks } from "../lib/api";
import { shorten, timeAgo, fmtNum } from "../lib/format";

export default function Blocks() {
  const [blocks, setBlocks] = useState([]);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try { const b = await getBlocks(30); if (alive) setBlocks(b.blocks); } catch {}
    };
    load();
    const id = setInterval(load, 4000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  return (
    <div className="fade-in" data-testid="blocks-page">
      <div className="mb-4">
        <span className="eyebrow" style={{ color: "var(--amber)" }}>Explorer</span>
        <h1 className="font-display text-[24px] font-extrabold mt-1">Blocks</h1>
      </div>
      <Panel title="Recent Blocks" action={<LiveTag />} bodyClass="overflow-auto">
        <table className="dt">
          <thead>
            <tr><th>Block</th><th>Age</th><th>Txns</th><th>Validator</th><th>Gas Used</th><th>Gas Limit</th><th>Size</th></tr>
          </thead>
          <tbody>
            {blocks.map((b) => (
              <tr key={b.hash} onClick={() => (window.location.href = `/block/${b.number}`)} data-testid={`blocks-row-${b.number}`}>
                <td><Link to={`/block/${b.number}`} className="link-amber mono font-semibold" onClick={(e) => e.stopPropagation()}>#{b.number}</Link></td>
                <td className="mono text-[12px]" style={{ color: "var(--muted)" }}>{timeAgo(b.timestamp)}</td>
                <td><span className="pill pill-muted">{b.txCount}</span></td>
                <td className="mono text-[12px]" style={{ color: "var(--muted)" }}>{shorten(b.miner, 8, 6)}</td>
                <td className="mono text-[12px]">{fmtNum(b.gasUsed)}</td>
                <td className="mono text-[12px]" style={{ color: "var(--muted)" }}>{fmtNum(b.gasLimit)}</td>
                <td className="mono text-[12px]" style={{ color: "var(--muted)" }}>{fmtNum(b.size)} B</td>
              </tr>
            ))}
            {blocks.length === 0 && <tr><td colSpan={7} className="text-center py-10" style={{ color: "var(--muted)" }}>Loading…</td></tr>}
          </tbody>
        </table>
      </Panel>
    </div>
  );
}
